import { buildShopSearchForm } from '@pcln/build-shop-search-form'
import { LOCATION_SEARCH_TYPE } from '@/types'
import { formatDate } from './date-helper'
import getComponentsFromTripType from './get-components-from-triptypes'

type PackageSearchParams = {
  roomCount: number
  adultCount: number
  childrenCount: number
  childrenAges: number[]
  startDate: string
  endDate: string
  tripType: string
  endLocationObject: LOCATION_SEARCH_TYPE | null
  startLocationObject?: LOCATION_SEARCH_TYPE | null
  hotelStartDate?: string
  hotelEndDate?: string
  isPartialStayDateValid?: boolean
  isRecommendedTrip?: boolean
  includeBasicEconomy?: boolean
}
const packagesSearch = ({
  roomCount = 1,
  adultCount = 2,
  childrenCount = 0,
  childrenAges = [],
  startDate = '',
  endDate = '',
  startLocationObject,
  endLocationObject,
  hotelStartDate = '',
  hotelEndDate = '',
  tripType = 'STAY:FLY',
  isPartialStayDateValid,
  isRecommendedTrip = false,
  includeBasicEconomy = true,
  ...rest
}: Partial<PackageSearchParams> & Record<string, unknown>) => {
  const url = '/shop/search/'
  const childrenAgesMock: Record<string, number> = {}
  if (childrenCount > 0) {
    childrenAges.forEach((item, i) => {
      const index = i + 1
      const key = `child${index}`
      childrenAgesMock[key] = item
    })
  }

  const searchRequest = {
    rooms: roomCount,
    adultCount,
    childCount: childrenCount,
    children: childrenAgesMock,
    departureDate: formatDate(startDate),
    departureLocation: startLocationObject || endLocationObject,
    returnDate: formatDate(endDate),
    arrivalLocation: endLocationObject,
    pivotComponentKey: 0,
    isRecommendedTrip,
    components: getComponentsFromTripType(tripType, {
      isPartialStayDateValid,
      includeBasicEconomy,
      hotelStartDate: formatDate(hotelStartDate, 'yyyy-MM-dd'),
      hotelEndDate: formatDate(hotelEndDate, 'yyyy-MM-dd'),
      hotelLocation: endLocationObject?.city,
      roomCount,
      isCarRequired: tripType.includes('DRIVE'),
      ...rest
    })
  }

  const form = buildShopSearchForm(url, searchRequest)
  form.submit()
}

export default packagesSearch
